module.exports=[
  "current-game-count",
  "current-user-count",
  "current-user-names",
  "current-games-info",
  "check-user-name",
  "create-user",
  "logout"
]